import { Link } from "react-router-dom";
import type { AnimeItem } from "@/mocks/anime";

interface AnimeCardProps {
  anime: AnimeItem;
}

export default function AnimeCard({ anime }: AnimeCardProps) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-transform duration-300 hover:-translate-y-1 hover:border-primary-200">
      <Link to={`/article/${anime.id}`} className="relative block aspect-[3/4] w-full overflow-hidden" aria-label={`查看《${anime.title}》详情`}>
        <img
          src={anime.cover}
          alt={`${anime.title} 动漫封面`}
          title={`${anime.title} 动漫`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <span className="absolute left-2 top-2 rounded-full bg-background-950/70 px-2.5 py-1 text-xs text-background-50 backdrop-blur">
          {anime.status}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-semibold text-background-50">
          <i className="ri-star-fill text-[10px]"></i>
          {anime.rating.toFixed(1)}
        </span>
        <span className="absolute bottom-2 left-2 rounded-md bg-accent-500 px-2.5 py-1 text-xs font-medium text-foreground-950">
          {anime.region}
        </span>
      </Link>
      <div className="flex flex-1 flex-col gap-2 p-3 md:p-4">
        <h3 className="truncate font-heading text-base text-foreground-950 md:text-lg">
          <Link to={`/article/${anime.id}`} className="hover:text-primary-600 transition-colors">
            {anime.title}
          </Link>
        </h3>
        <p className="line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
          {anime.description}
        </p>
        <div className="mt-auto flex flex-wrap items-center gap-1.5 pt-1">
          {anime.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}